import { Button, Modal, type ModalProps } from 'flowbite-react';
import { useCallback } from 'react';

export interface InfoModalProps extends ModalProps {
    message: string;
    closeLabel?: string;
}

export const InfoModal = ({
    show,
    message,
    closeLabel = 'Zavřít',
    onClose
}: InfoModalProps) => {
    const handleClose = useCallback(() => {
        onClose?.();
    }, [ onClose ]);

    return (
        <Modal show={show} size="md" onClose={onClose} popup>
            <Modal.Header />
            <Modal.Body>
                <div className="text-center">
                    <div className='flex flex-col items-center gap-4'>
                        <h3 className="mb-5 font-medium text-gray-800 dark:text-gray-400">{message}</h3>
                    </div>
                    <div className="flex justify-center gap-4">
                        <Button
                            color="gray"
                            onClick={handleClose}
                        >{closeLabel}</Button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};
